import { defineMessages } from "react-intl";
import React from "react";
import { messages } from "./constants";

const Translations = defineMessages(JSON.parse(JSON.stringify(messages)));

export default Translations;
